import { Color } from './java/Color';
import { Graphics2D } from './java/Graphics2D';
import { Rectangle } from './java/Geom';
import { Random } from './java/Random';
import { GameObject } from './GameObject';
import { Handler } from './Handler';
import { ID } from './ID';
import { TrailPool } from './TrailPool';
import { Game } from './Game';

export class MenuParticle extends GameObject {
  private static readonly SIZE = 16;
  private handler: Handler;
  private col: Color;
  private trailTick = 0;

  constructor(x: number, y: number, id: ID, handler: Handler) {
    super(x, y, id);
    this.handler = handler;

    const r = new Random();
    this.velX = r.nextInt(15) - 7;
    this.velY = r.nextInt(15) - 7;
    if (this.velX === 0) this.velX = 1;
    if (this.velY === 0) this.velY = 1;

    this.col = new Color(r.nextInt(255), r.nextInt(255), r.nextInt(255));
  }

  getBounds(): Rectangle {
    return new Rectangle(Math.trunc(this.x), Math.trunc(this.y), MenuParticle.SIZE, MenuParticle.SIZE);
  }

  tick(): void {
    this.x += this.velX;
    this.y += this.velY;
    if (this.y <= 0 || this.y >= Game.HEIGHT - MenuParticle.SIZE * 2) this.velY *= -1;
    if (this.x <= 0 || this.x >= Game.WIDTH - MenuParticle.SIZE) this.velX *= -1;
    if (++this.trailTick % 3 === 0)
      TrailPool.add(this.x, this.y, this.col, MenuParticle.SIZE, MenuParticle.SIZE, 0.04);
  }

  render(g: Graphics2D): void {
    const g2 = g;
    g2.setColor(this.col);
    g2.fillRoundRect(Math.trunc(this.x), Math.trunc(this.y), MenuParticle.SIZE, MenuParticle.SIZE, 6, 6);
  }
}
